const getItem = (key) => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }
    catch (e) {
        return null;
    }
};
const setItem = (key, value) => {
    if (!localStorage) {
        return;
    }
    localStorage.setItem(key, JSON.stringify(value));
};
const isLocalStorageAvailable = () => {
    return localStorage ? true : false;
};

export { getItem, isLocalStorageAvailable, setItem };
